export default __webpack_public_path__ + "static/media/BirdPage1.43c1e2d8.txt";